module.exports = __webpack_public_path__ + "static/media/glasgow.7ee3dbbe.png";